import makeStyles from '@mui/styles/makeStyles'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { OrderEditDialog } from '../dialogs/OrderEditDialog'
import { OrderDetailDialog } from '../dialogs/OrderDetailDialog'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import TraderDiaryTableRow from './TraderDiaryTableRow'
import { newThemeObject } from '../../newTheme'
import { useTraderDiaryFilters } from '../../hooks/useTraderDiaryFilters'
import { MassOrderInputDialog } from '../dialogs/MassOrderInputDialog'
import { newTraderDiary } from '../../constants/initialStates'
import { useState } from 'react'
import { ClearConfirmationAlert } from '../massOrderInputDialog/ClearConfirmationAlert'
import { useTraderDiaryApi } from '../../hooks/useTraderDiaryApi'

const useStyles = makeStyles(theme => ({
  tableHead: {
    ...newThemeObject.table.tableHead,
  },
  tableHeadChildrenText: {
    ...newThemeObject.table.tableHeadChildrenText,
  },
  tableHeadChildren: {
    ...newThemeObject.table.tableHeadChildren,
  },
  tableHeadChildrenFirst: {
    ...newThemeObject.table.tableHeadChildrenFirst,
  },
  tableHeadChildrenLast: {
    ...newThemeObject.table.tableHeadChildrenLast,
  },
  table: {
    minWidth: 650,
  },
  iconSize: {
    height: '20px',
    width: '40px',
    lineHeight: '18px',
    fontSize: '10px',
  },
  columnCell: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    color: '#000',
  },
}))

interface TraderDiaryTableProps {
  setTraderDiaryCheck: (traderDiaryId: number, valueDiary: boolean) => any
}

export const TraderDiaryTable = ({setTraderDiaryCheck}: TraderDiaryTableProps) => {
  const classes = useStyles()
  const traderDiaryTableRows = useTraderDiaryFilters()
  const { t } = useTranslation()
  const [traderDiary, setTraderDiary] = useState(newTraderDiary)
  const [orderAlertOpen, setOrderAlertOpen] = useState(false)
  const { updateStateDiaryToCancel } = useTraderDiaryApi();

  const orderAlertOk = () => {
    setOrderAlertOpen(false)
    cancleTraderDiary()
  }

  const orderAlertCancel = () => {
    setOrderAlertOpen(false)
  }

  const cancleTraderDiary = () => {
    updateStateDiaryToCancel(traderDiary.traderDiaryId)
  }
  
  return (
    <>
      <TableContainer
        component={Paper}
        style={{
          padding: '10px',
          borderRadius: newThemeObject.roundness.basic,
        }}
        elevation={0}
      >
        <Table className={`${classes.table}`} size="small" aria-label="simple table">
          <TableHead>
            <TableRow className={classes.tableHead}>
              <TableCell className={classNames([classes.tableHeadChildren, classes.tableHeadChildrenFirst])} />
              <TableCell className={classes.tableHeadChildren}>
                <p className={classes.tableHeadChildrenText}>{t('CRETATION_DATE')}</p>
              </TableCell>
              <TableCell className={classes.tableHeadChildren}>
                <p className={classes.tableHeadChildrenText}>{t('CLIENT')}</p>
              </TableCell>
              <TableCell className={classes.tableHeadChildren}>
                <p className={classes.tableHeadChildrenText}>{t('DIRECTION_ORDER_TYPE')}</p>
              </TableCell>
              <TableCell className={classes.tableHeadChildren}>
                <p className={classes.tableHeadChildrenText}>{t('DATE_FROM')}</p>
              </TableCell>
              <TableCell className={classes.tableHeadChildren}>
                <p className={classes.tableHeadChildrenText}>{t('PRICE_UNIT')}</p>
              </TableCell>
              <TableCell className={classes.tableHeadChildren}>
                <p className={classes.tableHeadChildrenText}>{t('AMOUNT_CURRENCY')}</p>
              </TableCell>
              <TableCell className={classes.tableHeadChildren}>
                <p className={classes.tableHeadChildrenText}>{t('INSTRUMENT')}</p>
              </TableCell>
              <TableCell className={classes.tableHeadChildren}>
                <p className={classes.tableHeadChildrenText}>{t('ORDER_STATE')}</p>
              </TableCell>
              <TableCell className={classes.tableHeadChildren}>
                <p className={classes.tableHeadChildrenText}>{t('INVESTOR_DIARY')}</p>
              </TableCell>
              <TableCell  className={classNames([classes.tableHeadChildren, classes.tableHeadChildrenLast])}/>
            </TableRow>
          </TableHead>
          <TableBody>
            {traderDiaryTableRows.map((row, index) => (
              <TraderDiaryTableRow 
                key={index} row={row} 
                isLast={index === traderDiaryTableRows.length - 1} 
                setTraderDiaryCheck={setTraderDiaryCheck} 
                setTraderDiary={setTraderDiary}
                setOrderAlertOpen={setOrderAlertOpen}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <OrderEditDialog />
      <OrderDetailDialog />
      <MassOrderInputDialog traderDiary={traderDiary} isFromTrader={true}/>
      <ClearConfirmationAlert
          alertOpen={orderAlertOpen}
          onOk={orderAlertOk}
          onCancel={orderAlertCancel}
          alertText={t('TRADER_CANCEL_MESSAGE')}
          inProgress={false}
      />
      
    </>
  )
}
